import { TableData } from 'services/api/api-client.types.ts';
import { simpleHtmlRegex } from '../../../documents/components/table-helper.ts';
import DOMPurify from 'dompurify';
import styles from './SimpleHtmlTable.module.scss';

type SimpleHtmlTableProps = {
  table: TableData;
};

export const SimpleHtmlTable = (props: SimpleHtmlTableProps) => {
  return (
    <table className={styles.tableContainer}>
      <thead>
        <tr>
          {props.table.columns.map((column) => {
            const headerCellText = props.table.fields[0][column];

            return (
              <th
                key={headerCellText}
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(headerCellText),
                }}
              />
            );
          })}
        </tr>
      </thead>

      <tbody>
        {props.table.fields.slice(1).map((row, rowIndex) => (
          <tr key={rowIndex}>
            {props.table.columns.map((column) => {
              const cellText = row[column];

              return (
                <td key={column}>
                  {typeof cellText === 'string' &&
                  cellText.match(simpleHtmlRegex) ? (
                    <span
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(cellText),
                      }}
                    />
                  ) : (
                    String(cellText ?? '')
                  )}
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
};
